var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXlsFiles01 = function SvgXlsFiles01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "xls_files-01_svg2__a",
    x1: 52.49,
    x2: 167.69,
    y1: 186.51,
    y2: 41.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#xls_files-01_svg2__a",
    id: "xls_files-01_svg2__b",
    x1: 44.24,
    x2: 159.44,
    y1: 179.97,
    y2: 34.84
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#xls_files-01_svg2__a",
    id: "xls_files-01_svg2__c",
    x1: 26.82,
    x2: 142.02,
    y1: 166.14,
    y2: 21.01
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#xls_files-01_svg2__a",
    id: "xls_files-01_svg2__d",
    x1: 8.31,
    x2: 123.51,
    y1: 151.45,
    y2: 6.32
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M193.16 54.12 142.2 1.18A3.88 3.88 0 0 0 139.43 0H63.49c-8.5 0-15.41 6.91-15.41 15.41v53.82H17.3c-6.36 0-11.53 5.17-11.53 11.53v57.71c0 6.36 5.17 11.53 11.53 11.53h30.78v34.62c0 8.48 6.91 15.38 15.41 15.38h115.33c8.5 0 15.41-6.9 15.41-15.37V56.79c0-.99-.39-1.95-1.08-2.67Zm-52.78-43.74 41.83 43.46h-41.83zM17.3 142.31c-2.12 0-3.84-1.72-3.84-3.84V80.76c0-2.12 1.72-3.84 3.84-3.84h103.86c2.12 0 3.84 1.72 3.84 3.84v57.71c0 2.12-1.72 3.84-3.84 3.84zm169.24 42.32c0 4.23-3.46 7.68-7.72 7.68H63.49c-4.26 0-7.72-3.45-7.72-7.69V150h65.39c6.36 0 11.53-5.17 11.53-11.53V80.76c0-6.36-5.17-11.53-11.53-11.53H55.77V15.41c0-4.25 3.46-7.71 7.72-7.71h69.2v50c0 2.12 1.72 3.85 3.85 3.85h50v123.09Z",
    style: {
      fill: "url(#xls_files-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.54 108.68c-1.56-.82-3.95-1.61-7.2-2.38s-5.29-1.5-6.13-2.21q-.99-.84-.99-2.01c0-.86.35-1.54 1.06-2.05 1.1-.8 2.61-1.19 4.55-1.19s3.29.37 4.23 1.12c.94.74 1.55 1.96 1.84 3.66l6.67-.29c-.1-3.03-1.2-5.46-3.3-7.28q-3.15-2.73-9.36-2.73c-2.54 0-4.71.38-6.5 1.15-1.8.77-3.17 1.88-4.12 3.35s-1.43 3.04-1.43 4.72c0 2.61 1.01 4.83 3.04 6.65q2.16 1.935 7.53 3.27 4.17 1.035 5.34 1.44c1.14.41 1.94.88 2.4 1.43s.69 1.21.69 2c0 1.22-.54 2.28-1.63 3.19s-2.71 1.36-4.86 1.36q-3.045 0-4.83-1.53c-1.19-1.02-1.99-2.62-2.38-4.8l-6.49.63c.44 3.7 1.77 6.51 4.01 8.44s5.45 2.9 9.62 2.9c2.87 0 5.27-.4 7.19-1.21 1.92-.8 3.41-2.03 4.46-3.68s1.58-3.43 1.58-5.32c0-2.09-.44-3.84-1.32-5.26s-2.1-2.54-3.65-3.36Z",
    style: {
      fill: "url(#xls_files-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.99 94.16h-6.67v32.76h23.26v-5.56H65.99z",
    style: {
      fill: "url(#xls_files-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7 93.89h-7.73l-6.49 10.61-6.62-10.61h-7.8l10.23 15.79L25 126.92h8l7.35-11.42 7.32 11.42h8.05l-11.29-16.99z",
    style: {
      fill: "url(#xls_files-01_svg2__d)"
    }
  }));
};
export default SvgXlsFiles01;